import React from 'react';
import styled from 'styled-components';
import { getSirvImgUrlExterior, getImgUrlExterior } from '../../../../modules/Vehicles/helpers';
import cn from 'classnames';

const Container = styled.div`
  min-width: 150px;
  max-width: 150px;
  min-height: 50px;
  margin: 6px;

  .avatarImg {
    max-width: 100%;
    height: auto;
    overflow: hidden;
  }

  @media (max-width: 768px) {
    width: 300px;
    height: 160px;
  }
  @media (max-width: 450px) {
    width: 150px;
    height: 80px;
  }

  position: relative;

  .img {
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center center;
    width: 150px;
    height: 85px;
    margin-top: -30px;
    margin-bottom: -20px;
    clip-path: inset(15px 0 0 0);
  }
`;

export const VehicleAvatar = function(props) {
  return (
    <>
      <Container className={cn('avatar', props.className)} vehicle={props.vehicle} onClick={props.onClick}>
        <div
          className={cn('img', 'bottom', props.className)}
          style={{
            backgroundImage: `${
              props.vehicle?.action_ws2_interior_inspection_done === '1'
                ? `url('${getImgUrlExterior(props.vehicle?.helga_id || props.vehicle?.id, '01')}')`
                : `url('/public/images/placeholder.png')`
            }`,
          }}
        ></div>
      </Container>
    </>
  );
};
